import { render, staticRenderFns } from "./UsersTagInput.vue?vue&type=template&id=4cce4748&"
import script from "./UsersTagInput.vue?vue&type=script&lang=js&"
export * from "./UsersTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports